
import { BrowserRouter } from "react-router-dom";
import { Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/toaster";
import { Suspense, lazy } from "react";
import { LoadingOverlay } from "@/components/LoadingOverlay";
import { BrandingProvider } from "@/contexts/BrandingContext";

// Dynamically import components
const Index = lazy(() => import("@/pages/Index"));
const Dashboard = lazy(() => import("@/components/Dashboard"));
const Settings = lazy(() => import("@/pages/Settings"));
const Agents = lazy(() => import("@/pages/Agents"));
const Leads = lazy(() => import("@/pages/Leads"));
const AgentProfile = lazy(() => import("@/pages/AgentProfile"));
const Analytics = lazy(() => import("@/pages/Analytics"));
const Help = lazy(() => import("@/pages/Help"));
const NotFound = lazy(() => import("@/pages/NotFound"));

function App() {
  return (
    <BrandingProvider>
      <BrowserRouter>
        <Suspense fallback={<LoadingOverlay show={true} />}>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/agents" element={<Agents />} />
            <Route path="/leads" element={<Leads />} />
            <Route path="/agent-profile" element={<AgentProfile />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/help" element={<Help />} />
            <Route path="/404" element={<NotFound />} />
            <Route path="*" element={<Navigate to="/404" replace />} />
          </Routes>
        </Suspense>
        <Toaster />
      </BrowserRouter>
    </BrandingProvider>
  );
}

export default App;
